import type { NestedI18nObject } from '../../utils';

const crossborder: NestedI18nObject = {
  // 跨境电商登录页面
  login: {
    title: 'CrossBorder ERP',
    subtitle: '全球跨境电商管理平台',
    welcome: '欢迎来到跨境电商ERP！',
    email: {
      placeholder: '邮箱地址',
      required: '请输入邮箱地址',
      invalid: '请输入有效的邮箱地址',
    },
    password: {
      placeholder: '密码',
      required: '请输入密码',
      min: '密码至少8位字符',
    },
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    loginButton: '登录',
    loginProgress: '登录中...',
    registerText: '还没有账户？',
    registerLink: '立即注册',
    success: '登录成功，欢迎来到跨境电商ERP！',
    failure: '登录失败，请检查邮箱和密码',
    failureTitle: '登录失败',
    failureDesc: '邮箱或密码错误，请重试',
  },

  // 功能特色
  features: {
    amazon: 'Amazon集成',
    warehouse: '智能仓储',
    orders: '订单管理',
    global: '全球市场',
  },

  // 信息面板
  panel: {
    title: '专业的跨境电商解决方案',
    multiplatform: {
      title: '多平台集成',
      desc: '支持Amazon、eBay等主流电商平台',
    },
    global: {
      title: '全球化支持',
      desc: '多语言、多货币、多时区管理',
    },
    inventory: {
      title: '智能库存',
      desc: '实时库存跟踪，自动补货提醒',
    },
  },

  // 底部链接
  footer: {
    about: '关于我们',
    help: '帮助中心',
    privacy: '隐私政策',
  },
};

export default crossborder;
